import type dayjs from 'dayjs';
import { TransformStringToDayJS } from './utils';

export enum OutreachChannel {
  CALL = 'call',
  EMAIL = 'email',
  SMS = 'sms',
}

/**
 * Interface for entities with outreach tracking fields.
 * Use for components that display outreach history (Invoice, Partner, PartnerListSummary).
 */
export interface OutreachInfo {
  readonly last_outreach_at: dayjs.Dayjs | null;
  readonly last_outreach_channel: OutreachChannel | null;
  readonly last_outreach_to: string | null;
}

export type CommunicationChannel = 'email' | 'call';

export enum AuthType {
  API_KEY = 'api_key',

  BASIC = 'basic',

  OAUTH2 = 'oauth2',
}

export class IntRange {
  lower: number | null;

  step: number | null;

  upper: number | null;
}

export class DateTimeRange {
  @TransformStringToDayJS()
  lower: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  step: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  upper: dayjs.Dayjs | null;
}

export enum TransactionDirection {
  CREDIT = 'credit',
  DEBIT = 'debit',
}

export type AgentParsingErrorCode =
  | 'duplicate'
  | 'extend_workflow_failed'
  | 'insufficient'
  | 'invalid_file_type'
  | 'invalid_transaction_data'
  | 'irrelevant'
  | 'missing_period_dates'
  | 'no_extraction_data'
  | 'no_matching_account'
  | 'processing_error'
  | 'upload_missing';

export interface AgentMetrics {
  agentConfidenceReason: string | null;

  agentConfidenceScore: number | null;

  agentErrorCode: AgentParsingErrorCode | null;

  agentUncertainties: string[];
}
